import React from 'react';
import { Tabs, TabsProps } from '@mui/material';

/**
 * MUI Tabs v5.0.x throws in updateScrollButtonState when a debounced resize
 * handler runs after unmount (tabsRef.current is null). See GRADMAP-FRONTEND-E.
 * scrollButtons=false skips that code path; tabs stay horizontally scrollable.
 */
export function ScrollableTabs(props: TabsProps) {
  const { scrollButtons = false, variant = 'scrollable', ...rest } = props;
  return <Tabs variant={variant} scrollButtons={scrollButtons} {...rest} />;
}

export default ScrollableTabs;
